<template>
    <div class="popup popup-rooms" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  style="display: block;" id="connectRooms">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>多人连通房</p>
            <a class="shorexDetail-returnButton" @click="goBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="c_content">
            <img src="https://resource.rcclchina.com.cn/connectRoom/connect-room-popup.jpg" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: "ConnectRoomPopup",
    props: {
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        }
    },
    methods: {
        goBack () {
            this.onGoBack()
        }
    },
}
</script>

<style lang="less" scoped>
.popup {
    position: fixed;
}
// .shorexDetail-title {
//     padding: 15px 20px;
//     background-color: #fff;
//     overflow: hidden;
//     text-align: center;
//     margin-bottom: 10px;
//     position: fixed;
//     width: 100%;
//     z-index: 10;
//     > p {
//         
//         font-size: 14px;
//         color: #333333;
//         letter-spacing: 1px;
//         text-align: center;
//         margin: 0;
//     }
//     .shorexDetail-returnButton {
//         width: 30px;
//         position: absolute;
//         top: 15px;
//         left: 20px;
//         text-align: left;
//     }
//     > img {
//         width: 33%;
//     }
// }
</style>